import { render, staticRenderFns } from "./PointListHistoryLayout.vue?vue&type=template&id=3f8a70c8&scoped=true"
import script from "./PointListHistoryLayout.vue?vue&type=script&lang=js"
export * from "./PointListHistoryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a70c8",
  null
  
)

export default component.exports